import React, { Component, } from 'react'
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Layout from '../components/AppLayout/layout'
import HomePage from '../pages/HomePage'
import MessagePage from '../pages/MessagePage'
import ViewPage from '../pages/ViewPage'
import GalleryPage from '../pages/GalleryPage'
import IntroPage from '../pages/IntroPage'
import './app.css'

export default class App extends Component {
    static childContextTypes = {
        host: PropTypes.string
    }

    //define application wide context settings here
    getChildContext() {
        return {
            host: 'https://snowflakeapi.datausa.com' //'http://localhost:4981'
        }
    }

    render() {
        return (
            <Route render={(props) => {

               return (
                    <Layout {...props} >
                        <Switch>
                           <Route exact path='/'>
                               <IntroPage />
                            </Route>
                            <Route exact path='/create'>
                                <HomePage />
                            </Route>
                           <Route exact path='/message'>
                                <MessagePage {...props} />
                            </Route>
                            <Route path='/view/:id' render={(props) =>
                                <ViewPage {...props} />}>
                            </Route>
                            <Route path='/gallery'>
                                <GalleryPage />
                            </Route>
                            <Route path="/intro">
                                <IntroPage/>
                            </Route>
                        </Switch>
                    </Layout>
                )
            }}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/config/app.js